import { render, staticRenderFns } from "./offline.vue?vue&type=template&id=723e4c1a&scoped=true"
import script from "./offline.vue?vue&type=script&setup=true&lang=js"
export * from "./offline.vue?vue&type=script&setup=true&lang=js"
import style0 from "./offline.vue?vue&type=style&index=0&id=723e4c1a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723e4c1a",
  null
  
)

export default component.exports